import { render, staticRenderFns } from "./BaseAbout.vue?vue&type=template&id=9988cf6c&scoped=true&"
import script from "./BaseAbout.vue?vue&type=script&lang=js&"
export * from "./BaseAbout.vue?vue&type=script&lang=js&"
import style0 from "./BaseAbout.vue?vue&type=style&index=0&id=9988cf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9988cf6c",
  null
  
)

export default component.exports